import { Pipe } from '@angular/core';
var NgXtruncatePipe = (function () {
    function NgXtruncatePipe() {
    }
    NgXtruncatePipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var limit = args[0] ? parseInt(args[0]) : 10;
        var trail = args[1] ? args[1] : '...';
        var txt = document.createElement('textarea');
        txt.innerHTML = value;
        return txt.value.length > limit ? String(txt.value).replace(/<[^>]+>/gm, '').substring(0, limit) + trail : String(txt.value).replace(/<[^>]+>/gm, '');
    };
    return NgXtruncatePipe;
}());
export { NgXtruncatePipe };
NgXtruncatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'ngXtruncate',
            },] },
];
/** @nocollapse */
NgXtruncatePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ngxtruncate.js.map